define('views/parts/menu/menu-datepicker',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // services
    'services/api',
    'services/i18n',
    // parent
    'views/parts/menu/menu-item',
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    //services
    API,
    i18n,
    // parent
    VMenuItem
) {

    var VMenuDatePicker = VMenuItem.extend({

        initialize: function(opt) {
            var itemModel = this.itemModel = this.model.get('model'),
                model = this.model;

            if (!itemModel) {
                this.itemModel = itemModel = new Backbone.Model();
                itemModel.set(model.get('attribute'), API.formatDate(moment()));
            }

            this.listenTo(itemModel, "change:" + model.get('attribute'), this.onChange);
            VMenuDatePicker.__super__.initialize.call(this, opt);
        },

        render: function() {
            VMenuDatePicker.__super__.render.apply(this, arguments);
            this.initDatepicker()
                .setContent(this.getValue())
                .setDate(this.getValue());
        },

        initDatepicker: function() {
            this.$input = this.$input || Backbone.$('<input type="text" class="menu-datepicker-input" aria-hidden="true" tabindex="-1" style="position:absolute;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;">');
            this.$el.css('position', 'relative');
            if (!this.$input.parent().length) {
                this.$el.append(this.$input);
            }

            this.$input.datepicker({
                autoclose: true,
                todayHighlight: true,
                language: i18n.language.substring(0, 2)
            }).on('changeDate', this.onDatePicked.bind(this));
            return this;
        },

        setContent: function(content) {
            this.model.set('content', content);
            return this;
        },

        setDate: function(date) {
            this.$input.datepicker("setDate", date);
            return this;
        },

        setValue: function(value, options) {
            this.itemModel.set(this.model.get('attribute'), value, options);
        },

        getValue: function() {
            return this.itemModel.get(this.model.get('attribute'));
        },

        onClick: function() {
            this.$input.datepicker('show');
            VMenuDatePicker.__super__.onClick.apply(this, arguments);
        },

        onChange: function(model, value) {
            this.setContent(value);
        },

        onDatePicked: function(e) {
            var formattedDate = API.formatDate(e.date);
            this.setContent(formattedDate)
                .setValue(formattedDate);
        },

    });

    return VMenuDatePicker;

});

